export const REQUEST_TIMEOUT = 60000; // default request timeout in ms, 1min
export const NETWORK_ERROR_REGEX = /network error/i;
export const REQUEST_ERROR_REGEX = /request aborted/i;
export const USER_ABORTED_REQUEST_ERROR = /The user aborted a request/i;
